module.exports = __webpack_public_path__ + "img/icon_auth_three.9287f7ed.png";